export const html = "<p>Carve your own Armenian cross-stone.</p>\n";
export const leadHtml = "<p>Carve your own Armenian cross-stone.</p>\n";
export const bodyHtml = "";
export const metaText = "Carve your own Armenian crossstone.";